"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t&.editable {\n\t\tsvg {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\tsvg {\n\t\t& + svg {\n\t\t\tmargin-left: 2px;\n\t\t}\n\t}\n"], ["\n\t&.editable {\n\t\tsvg {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\tsvg {\n\t\t& + svg {\n\t\t\tmargin-left: 2px;\n\t\t}\n\t}\n"])));
var templateObject_1;
